<template>
    <div class="related-elements pointer">
        <div class="related-elements-flex add-relative">
            <div class="roboto-normal-18 clr-black-38 mr-2 mb-1" @click="notShowRelElements = true">Связи:</div>
            <RelatedLinks :element="element" :deleteElementsInTask="isTaskOrSub"/>
            <img class="ml-2 mr-2 pointer mb-1" height="33.91px" @click="notShowRelElements = true" src="@/assets/images/components/button-add-blue.png">
        </div>
        <RelatedWindow :element="element" :addElementsInTask="isTaskOrSub" v-if="notShowRelElements" @toCloseRelWindow="notShowRelElements = false"/>
    </div>
</template>

<script>
import RelatedWindow from './RelatedWindow'
import RelatedLinks from './RelatedLinks'
export default {
    name: 'RelatedElements',
    components: {
        RelatedWindow,
        RelatedLinks
    },
    props: ['element', 'relatedElementsForTask'],
    data() {
        return {
            notShowRelElements: false
        }
    },
    computed: {
        isTaskOrSub() {
            return this.relatedElementsForTask ? true : false
        }
    },
}
</script>

<style lang="scss" scoped>
.related-elements {
    .related-elements-flex {
        display: flex;
        align-items: center;
    }
}
</style>